<template>
  <div>
    <div class="search-wrap">
      <div class="left" @click="showPicker = true">
        {{ startDate ? startDate : '请选择时间' }}
      </div>
      <div class="right">
        <van-search v-model="keywords" placeholder="请输入搜索关键词"/>
      </div>
    </div>
    <van-popup v-model="showPicker" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        :max-date="maxDate"
        @cancel="showPicker = false"
        @confirm="confirmPicker"
      />
    </van-popup>
    <ul class="list-weekend-menu">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <li class="item" v-for="(item,index) in weekendList" :key="index">
            <div class="title">{{ item.Createtime.substr(0, 4) }}年{{ item.Createtime.substr(5, 2) }}月{{ item.Createtime.substr(8, 2) }}日</div>
            <div class="info-wrap">
              <div class="info-p"><span>发布人：</span>{{ item.Userdep }}-{{ item.UserName }}</div>
              <div class="info-p">
                <span>内&emsp;容：</span>
                <div class="info">
                  {{ item.ContentContent }}
                </div>
              </div>
              <div class="info-p">
                <span>评&emsp;级：</span>
                <div class="abc-wrap">
                  <div class="abc" :class="{'a':item.theRating==1}" @click="onGrade(1,index,item.id,item.theRating)">A</div>
                  <div class="abc" :class="{'b':item.theRating==2}" @click="onGrade(2,index,item.id,item.theRating)">B</div>
                  <div class="abc" :class="{'c':item.theRating==3}" @click="onGrade(3,index,item.id,item.theRating)">C</div>
                </div>
              </div>
            </div>
          </li>
        </van-list>
      </van-pull-refresh>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      weekendList: [],
      loading: false,
      finished: false,
      refreshing: false,
      page: 1,
      pcount: 10,
      allcount: 0,

      // minDate: new Date(2020, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(),
      showPicker: false,
      keywords: '',
      startDate: ''
    }
  },
  mounted() {
    // this.WebGetManagementToolLst();
  },
  watch: {
    keywords() {
      this.onRefresh()
    }
  },
  methods: {
    onLoad() {
      console.log('onLoad');
      this.WebGetManagementToolLst();
    },
    onRefresh() {
      this.finished = false;
      this.loading = true;
      this.page = 1;
      this.weekendList = [];
      this.onLoad()
    },
    WebGetManagementToolLst() {
      let searchkey = this.$basecode.base64encode(this.$basecode.utf16to8(this.keywords)) || ''
      let data = {
        StartDate: this.startDate,
        EndDate: this.startDate,
        SearchKey: searchkey,
        page: this.page,
        pcount: this.pcount
        // DepSysno: localStorage.getItem('GovDepSysno'),
      }
      this.$baseajax.normalJsonp(this.$base.baseapi + '/WebGetManagementToolLst', data, res => {
        console.log(res);
        if (this.refreshing) {
          this.refreshing = false;
        }
        this.loading = false
        res = res.WebGetManagementToolLstResult
        if (res.ResponseCode == 1) {
          this.allcount = res.AllCount;
          if (res.ItemLst) {
            this.weekendList.push(...res.ItemLst)
          }

          if (this.weekendList.length >= this.allcount) {
            this.finished = true
          } else {
            this.page++
          }
        } else {
          this.finished = true
        }
      }, err => {
      })

    },
    onGrade(grade, index, id, isRating) {
      // 当天评级？
      if (localStorage.getItem('isaudit') == 1) {
        // this.$dialog.confirm({
        //     title:''
        // })
        if (isRating != 0) {
          this.$toast('已评级')
          return
        }
        this.$dialog.confirm({
          title: '提示',
          message: '是否确认此评级？',
          confirmButtonColor: '#D32F2F'
        }).then(() => {
          let data = {
            id: id,
            usersysno: localStorage.getItem('UserSysno'),
            theRating: grade
          }
          this.$baseajax.normalJsonp(this.$base.baseapi + '/WebUpdateManagementTool', data, res => {
            console.log(res);
            res = res.WebUpdateManagementToolResult
            if (res.ResponseCode == 1) {
              this.weekendList[index].theRating = grade
            }
          }, err => {
          })
        }).catch(() => {
        })

      }
    },
    confirmPicker(e) {
      let year = e.getFullYear()
      let month = e.getMonth() + 1
      month = month < 10 ? '0' + month : month
      let day = e.getDate()
      day = day < 10 ? '0' + day : day
      this.startDate = year + '-' + month + '-' + day;
      this.onRefresh()
      this.showPicker = false
    },
  },
}
</script>

<style lang="less" scoped>
@import '~@/assets/base.less';

.search-wrap {
  margin: 0.28rem .28rem 0;
  padding: .18rem .25rem;
  background-color: #ffffff;
  box-shadow: 0rem 0.01rem 0.12rem 0rem rgba(26, 26, 26, 0.1);
  border-radius: 0.27rem;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .left {
    font-size: 0.33rem;
    color: #333333;
    padding-right: 0.25rem;
    margin-right: 0.25rem;
    border-right: 1px solid #c8c8c8;
  }

  .right {
    // width: 7rem;
    flex: 1;
    min-width: 0;
  }

  .van-search, .van-search .van-cell {
    padding: 0;
  }

  /deep/ .van-icon-search {
    color: #d1d1d1;
  }

  .van-search__content {
    background: #fff;
    padding-left: 0;
  }

  /deep/ .van-field__control {
    font-size: 0.33rem;
  }

}

.list-weekend-menu {
  padding-left: 0.28rem;
  padding-right: 0.28rem;

  .item {
    margin-top: 0.28rem;
    padding: .48rem;
    background-color: #ffffff;
    box-shadow: 0rem 0rem 0.28rem 0rem rgba(211, 47, 47, 0.14);
    border-radius: 0.27rem;

    .title {
      font-size: 0.4rem;
      color: #333333;
      display: flex;
      justify-content: space-between;
      margin-bottom: 0.3rem;

      span {
        min-width: 0.44rem;
        padding: 0 .1rem;
        height: 0.44rem;
        line-height: 0.44rem;
        border-radius: 100%;
        font-size: 0.32rem;
        color: #ffffff;
        background-color: @color;
        text-align: center;
      }
    }

    .info-p {
      display: flex;
      font-size: 0.3rem;
      color: #888888;
      margin-top: 0.1rem;

      span {
        width: 1.3rem;
        flex: 0 0 1.3rem;
        font-size: 0.32rem;
        color: #666666;
      }

      p {
        margin-bottom: 0.15rem;
      }
    }

    .abc-wrap {
      display: flex;

      .abc {
        width: 0.64rem;
        margin-right: 0.2rem;
        background-color: #d3d3d3;
        border-radius: 0.07rem;
        font-size: 0.3rem;
        color: #fffefe;
        text-align: center;
      }

      .a {
        background-color: #ff7200;
      }

      .b {
        background-color: #D32F2F;
      }

      .c {
        background-color: #ffeb7a;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/manage/Help.vue